<template>
    <div>
      <div class="columns">
        <div class="column is-12-tablet is-12-desktop">
          <h1 class="title is-4 between-center">
                    <span>
                        <span>Tasks</span>
                        <a v-if="! isView" href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                        <a v-if="isView && currentTableView && canEditView(currentTableView.id)" href="#" @click.prevent="openCustomViewModal(currentTableView.id)" class="gear">
                            <o-icon pack="fa" icon="edit" size="is-small"/>
                        </a>
                    </span>
          </h1>
        </div>
      </div>
        <div class="columns toolbar-box">
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-select placeholder="Task Type" v-model="filters.type" :expanded="true" @input="fetchPaginatedData(true)">
                        <option value="">Select Type</option>
                        <option
                            v-for="taskType in taskTypes"
                            :value="taskType.id"
                            :key="taskType.id"
                        >
                            {{ taskType.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <o-input
                        type="search"
                        v-model="filters.title"
                        placeholder="Title"
                        icon="search"
                        @change.native="fetchPaginatedData(true)"
                    ></o-input>
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                        type="user"
                        track="id"
                        field-name="full_name"
                        placeholder="Search by User"
                        v-model="filters.assignee_id"
                        @update:modelValue="fetchPaginatedData()"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-6-desktop has-text-right">
                <div class="field is-grouped is-grouped-right">
                    <p class="control">
                        <a @click.prevent="openCustomViewModal(null)" class="button is-info"><span>Create Custom View</span></a>
                    </p>
                    <p v-if="isResetFiltersButtonVisible" class="control">
                        <a @click.prevent="resetFilters" class="button is-info"><span>Reset filters</span></a>
                    </p>
                    <p v-if="isDeleteSelectedButtonVisible" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <a @click.prevent="isCalendarModalActive = true" class="button is-info"><span>View in Calendar</span></a>
                    </p>
                    <p class="control">
                        <router-link :to="newTaskRoute" class="button is-info" ><span class="icon"><i class="icm-new"></i></span><span>New</span></router-link>
                    </p>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-offset-2 is-6-tablet is-2-desktop">
                <o-field>
                    <autocomplete-select
                        v-model="filters.category_id"
                        type="category"
                        track="id"
                        field-name="name"
                        placeholder="Search by Category"
                        @update:modelValue="fetchPaginatedData()"
                    />
                </o-field>
            </div>
            <div class="column is-6-tablet is-2-desktop relative">
                <datepicker
                        v-model="filters.date"

                        placeholder="Due Date"
                        @update:modelValue="fetchPaginatedData()"
                />
            </div>
            <div class="column is-offset-4 is-4-tablet is-2-desktop has-text-right">
                <div class="field">
                    <o-checkbox
                            v-model="filters.is_package_log"
                            :true-value="1"
                            :false-value="0"
                            @update:modelValue="fetchPaginatedData()"
                    >
                        View package logs
                    </o-checkbox>
                </div>
            </div>
        </div>
        <custom-views-filter
                :view-id-prop="filters.table_view_id"
                type="tasks"
                @input="changeCustomView"
        />

        <o-table
            :class="projectId ? 'project-width-table' : 'fullwidth-table'"
            class="is-responsive is-responsive-wide project-width-table"

            v-if="isTableVisible && tasksTotal"
            :data="paginatedData"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :checkable="table.checkable"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            :checked-rows.sync="checkedRows"

            :loading="loading"
            :total="total"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
              <o-table-column
                  v-for="col in customViewTableColumns"
                  v-bind="col"
                  #default="{ row }"
                  :field="col.field"
                  :label="col.field === 'actions' ? '' : col.label"
                  :sortable="col.sortable"
              >
                <task-column v-if="col.field !== 'actions'" :field="col.field" :item="row" :project-id="projectId" />

                <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                  <template #trigger>
                    <button class="button">
                      <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                    </button>
                  </template>
                  <o-dropdown-item has-link><a @click="openReplyModal(row.id)">Reply</a></o-dropdown-item>
                  <o-dropdown-item has-link><a @click="openPreviewModal(row)">Print</a></o-dropdown-item>
                  <o-dropdown-item has-link><router-link :to="{ name: 'tasks.show', params: { slug: row.id }, query: {project_id: projectId} }">View Task</router-link></o-dropdown-item>
                  <o-dropdown-item has-link><a @click="openReminderModal(row.id)">Set Reminder</a></o-dropdown-item>
                </o-dropdown>
              </o-table-column>

            <template v-slot:empty>
              <div class="has-text-centered">
                This table is empty!
              </div>
            </template>
        </o-table>

        <total
                :is-filtered="isResetFiltersButtonVisible"
                :total-amount="tasksTotal"
                :filtered-amount="total"
        />

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReminderModalActive" has-modal-card>
            <reminder-modal :reference-id="taskId" reference-type="task"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCalendarModalActive" class="calendar-modal" has-modal-card>
            <calendar-modal :project-id="projectId"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isReplyModalActive" has-modal-card>
            <reply-modal :reference-id="taskId" reference-type="task"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isPreviewModalActive" class="preview-modal" has-modal-card>
            <preview-modal :file="currentPreviewFile"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isCustomViewModalActive" has-modal-card>
            <custom-view-modal
                    :custom-view="customViewToEdit"
                    type="tasks"
                    @custom-view-created="filters.table_view_id = $event"
                    @custom-view-deleted="filters.table_view_id = null"
            />
        </o-modal>
    </div>
</template>

<script>
    import SupportsCustomViews from "../mixins/SupportsCustomViews";
    import Datepicker from './../components/Datepicker'
    import { mapActions, mapGetters } from 'vuex'
    import CalendarModal from './modals/Calendar'
    import TaskColumn from './table-columns/Task'
    import PreviewModal from './modals/Preview'
    import Total from './../components/Total'
    import Table from '../mixins/Table'

    export default {
        components: {
            CalendarModal, TaskColumn, Datepicker, PreviewModal, Total
        },

        mixins: [Table, SupportsCustomViews],

        props: {
            projectId: {
                required: false
            }
        },

        data () {
            return {
                tableName: 'tasks-index',
                taskId: null,
                isPreviewModalActive: false,
                isCalendarModalActive: false,
                isReminderModalActive: false,
                isReplyModalActive: false,
                currentPreviewFile: null,
            }
        },

        computed: {
            ...mapGetters([
                'latestNoteMessageByTaskId',
                'categoryNameById',
                'contactNameById',
                'projectNameById',
                'taskStatuses',
                'userNameById',
                'taskTypes',
                'tasksTotal'
            ]),

            ...mapGetters({
                itemsByIds: 'tasksByIds'
            }),

            newTaskRoute() {
                return { name: 'tasks.create', query: {project_id: this.projectId} }
            }
        },

        created () {
            this.filters = {
                project_id: this.projectId,
                is_package_log: 0,
                assignee_id: '',
                category_id: '',
                title: '',
                date: '',
                type: '',
                table_view_id: null
            }
        },

        mounted () {
            this.fetchPaginatedData()
        },

        methods: {
            ...mapActions({
                partialUpdateTask: 'partialUpdateTask',
                removeItem: 'removeTask',
                fetchData: 'fetchTasks'
            }),

            openPreviewModal(task) {
                const port = window.location.port ? `:${window.location.port}` : '';
                this.currentPreviewFile = {
                    name: task.title,
                    mime: 'application/pdf',
                    path: `${window.location.protocol}//${window.location.hostname}${port}/tasks/${task.id}/pdf`,
                    generatedOnTheFly: true
                }
                this.isPreviewModalActive = true
            },

            openReminderModal (taskId) {
                this.isReminderModalActive = true
                this.taskId = taskId
            },

            openReplyModal (taskId) {
                this.isReplyModalActive = true
                this.taskId = taskId
            }
        }
    }
</script>

